import api from "@/apiConfig/api";
import apiV2 from "@/apiConfig/api-v2";

api.defaults.withCredentials = true;

export const getMarks = async (group_id, course_element_id) => {
  return await api.get(
    `/course_elements/group/${group_id}/course_element/${course_element_id}/student_projects`
  );
};
export const getDetails = async (group_id) => {
  return await api.get(
    `/course_elements/group/${group_id}/course_element/answer_details`,
    {
      params: {
        group_id,
      },
    }
  );
};

export const changeAnswerStatus = async (answer_id) => {
  return await api.post(`/courses/change_status?answer_id=${answer_id}`);
};

export const addTask = async (groupId, studentIds, courseElementIds) => {
  return await apiV2.post("/controls/booking/add-task", {
    group_id: groupId,
    student_ids: studentIds,
    course_element_ids: courseElementIds,
  });
};

export const getStudentTopics = async (groupId, studentId) => {
  return await apiV2.get("/controls/booking/tasks-teacher", {
    params: {
      group_id: groupId,
      student_id: studentId,
    },
  });
};

export const rateTutor = async (studentId, bookingId, rating) => {
  return await apiV2.post("/controls/booking/rate-tutor", {
    student_id: studentId,
    booking_id: bookingId,
    rating: rating,
  });
};
